import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import GET_OHTS_LIST from '@shared/queries/getOHTListQuery';

const useOhtList = (skip = false) => {
  const { data, loading, error } = useQuery(GET_OHTS_LIST, { skip });

  const ohtList = useMemo(() => {
    if (!data) {
      return [];
    }

    return data.officeOfHealthTechnologies.map(item => ({
      label: item.Value,
      value: item.Id,
      displayName: item.DisplayName
    }));
  }, [data]);

  return { ohtList, ohtListLoading: loading, ohtListError: error };
};

export default useOhtList;
